import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import * as R from 'ramda'
import { Typography } from '@material-ui/core'
import BeaconsTable from './BeaconsTable'
import BeaconFormDialog from './BeaconFormDialog'
import { useTableFetch, pageToSortPairs } from 'commons/reactTableFetch'
import effects from 'app/effects/effects'
import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import EmptyStateView from 'app/components/EmptyStateView'
import SearchBar from 'app/components/searchBar/SearchBar'
import NetworkError from 'app/components/NetworkError'
import BeaconOverview from './overview/BeaconOverview'
import { usePlace } from 'commons/usePlace'
import { useIsOnline } from 'commons/useIsOnline'

const fetchData = (page) => {
  const status = R.when(
    R.equals(FILTER_TYPE.ACTIVE_AND_INACTIVE),
    R.always(null),
  )(page.status)
  return effects.apis.getBeacons({
    page: page.currentPage,
    limit: page.pageSize,
    sort: pageToSortPairs(page),
    keyword: page.keyword,
    status,
  })
}

export const FILTER_TYPE = {
  ACTIVE_AND_INACTIVE: -1,
  ACTIVE: 1,
  INACTIVE: 0,
}

const INITIAL_FILTER = { status: FILTER_TYPE.ACTIVE_AND_INACTIVE }

const ManageBeacons = () => {
  const [isOpenBeaconFormDialog, setIsOpenBeaconFormDialog] = useState(false)
  const { formatMessage } = useIntl()
  const tableFetch = useTableFetch(fetchData, INITIAL_FILTER)
  const { search, refetchData, pageInfo } = tableFetch
  const place = usePlace()
  const [isOnline] = useIsOnline()
  const shouldShowEmptyView = () => {
    return pageInfo.isFirsttimeFetchingNoData
  }

  const isBeaconEnabled = R.path(['info', 'isBeaconEnabled'], place)

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => refetchData()} />
  }

  if (R.not(isBeaconEnabled)) {
    return <BeaconOverview />
  }

  return (
    <>
      <ContentToolbarPage
        isFitViewPort
        contentToolbar={
          <LargeToolbar
            content={
              <>
                <Typography variant="h6">
                  <FormattedMessage id="navigation.beacons.manageBeacons.label" />
                </Typography>
              </>
            }
            right={
              <>
                <SearchBar
                  className="ltr:mr-8 rtl:ml-8"
                  searchFor={formatMessage({
                    id: 'beacons.table.search.label',
                  })}
                  {...search}
                />
              </>
            }
          />
        }
        content={
          <>
            {shouldShowEmptyView() ? (
              <EmptyStateView
                title={<FormattedMessage id="beacons.table.empty.label" />}
              />
            ) : (
              <BeaconsTable {...tableFetch} />
            )}
          </>
        }
      />
      <BeaconFormDialog
        isOpen={isOpenBeaconFormDialog}
        onClose={() => setIsOpenBeaconFormDialog(false)}
        refetchData={refetchData}
      />
    </>
  )
}

export default ManageBeacons
